<template>
<div class="p-4">
    <div class="d-flex">
        <div class="mt-1 mb-0 d-inline-block btn-home">
            <button type="button" class="btn text-white me-3 mb-1" @click="mtdChangeView('reports')">
                <i class="fas fa-arrow-left"></i> Volver
            </button>
        </div>
        <div class="mt-1 mb-0 d-inline-block ms-auto btn-home">
            <button type="button" class="btn text-white me-3 mb-1" @click="mtdReportBead('DEPOSITO')">
                <i class="fas fa-money-bill-alt"></i> Reporte Deposito/Retiros
            </button>
            <button type="button" class="btn text-white mb-1" @click="mtdReportBead('INGRESO')">
                <i class="fas fa-money-bill-alt"></i> Reporte Ingresos
            </button>
            &nbsp;
            <button type="button" class="btn text-white mb-1" @click="mtdReportBead('EGRESO')">
                <i class="fas fa-money-check-alt"></i> Reporte Egresos
            </button>
            &nbsp;
            <button type="button" class="btn text-white mb-1" @click="returnHome">
                <i class="fas fa-home-lg-alt"></i> Inicio
            </button>
        </div>
    </div>

    <div class="row w-100 mt-3 pb-4" v-if="type !== 'DEPOSITO'">
        <div class="col-md-12 col-lg-12 col-xs-12 mt-3 p-2 text-center bg-main" v-if="type.length > 0">
            <div style="position: relative;">
                <h4 class="modal-title text-white" id="exampleModalLabel">
                    REPORTE DE CAJA - {{ this.type }}
                </h4>
                <div class="btn-home-jefatura mt-1" style="right: 0;top: 0;position: absolute;" v-if="type == 'EGRESO'">
                    <button type="button" class="btn btn-sm" @click="showGraficExpenseYear" :disabled="dataReport.length == 0">
                        <i class="fas fa-chart-line"></i> Gráfico Anual
                    </button>
                </div>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center p-4">
            <h3>Seleccione un tipo</h3>
        </div>
        <div class="col-md-12 col-lg-12 col-xs-12 mb-3">
            <div class="row mt-3 d-flex" v-if="type == 'INGRESO' || type == 'EGRESO'">
                <div class="col-md-4 col-xl-2 col-lg-3 mb-2">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">Sede</span>
                        <select id="campu_id" class="form-control form-control" v-model="filterModal.campu_id" @change="mtdSelectCampusToBox">
                            <option selected value="0" disabled>Seleccione ...</option>
                            <option v-for="(item, index) in dataCampus" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4 col-lg-3 col-xl-2 mb-3">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">Caja</span>
                        <select id="bead_id" class="form-control form-control" v-model="filterModal.bead_id" @change="mtdDataReport">
                            <option selected value="0" disabled>Seleccione ...</option>
                            <option v-for="(item, index) in dataBeadsList" :key="index" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-md-4 col-lg-3 col-xl-2 mb-2">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">Desde</span>
                        <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="begindate" v-model="filterModal.begindate" @change="mtdDataReport" />
                    </div>
                </div>
                <div class="col-md-4 col-lg-3 col-xl-2 mb-2">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text">Hasta</span>
                        <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="enddate" v-model="filterModal.enddate" @change="mtdDataReport" />
                    </div>
                </div>
                <div class="col-md-3 col-lg-2 col-sm-6 col-xs-12 mb-2">
                    <div class="form-check form-switch" v-if="type == 'EGRESO'">
                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" :checked="view == 'detallado' ? true : false" @change="mtdChangeState" />
                        <label class="form-check-label" for="flexSwitchCheckChecked">{{ view == 'detallado' ? "Detallado" :
                            "Consolidado" }}</label>
                    </div>
                </div>
                <div class="col-xl-2 col-md-2 col-sm-3 mb-3" v-if="type.length > 0 && view == 'detallado'">
                    <button type="button" name="accion" class="btn btn-sm mb-3 w-100 bg-main text-white" @click="exportExcel">
                        <i class="fas fa-file-excel"></i> Exportar
                    </button>
                </div>
                <div class="col-xl-2 col-md-2 col-sm-3 mb-3" v-if="type == 'EGRESO' && view !== 'detallado'">
                    <button type="button" name="accion" class="btn btn-sm mb-3 w-100 bg-main text-white" :disabled="dataConsolidado.length == 0" @click="showGrafic">
                        <i class="fas fa-chart-line"></i> Gráfico
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-lg-12 mb-2" v-if="type == 'INGRESO'">
            <!-- Colocar filtros  -->
             <div class="input-group input-group-sm">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkboxVenta" @change="calculateTotal"
                          v-model="filter.venta"
                        />
                        <label class="form-check-label" for="checkboxVenta">
                          Venta Directa
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkboxOT" @change="calculateTotal"
                          v-model="filter.orden"
                        />
                        <label class="form-check-label" for="checkboxOT">
                          Orden de Trabajo
                        </label>
                      </div>
                    </div>
        </div>
        <div v-if="this.type == 'INGRESO'" class="row">
            <!---Mostrar un resumen -->
            <div class="col-md-12 px-3" v-if="this.dataReport.length > 0">
                <div class="d-md-flex justify-content-between flex-wrap">
                    <div class="col-lg-3 col-xl-2 col-md-12 mt-2 px-1">
                        <div class="card border-main">
                            <div class="card-body">
                                <div>
                                    <i class="fas fa-money-bill color-main me-2"></i>
                                    <strong class="color-main">TOTAL: </strong>
                                    <span>S/. {{ finalCash.toFixed(2) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col px-1 mt-2" v-for="(item, index) in methods" :key="index">
                        <div class="card border-main">
                            <div class="card-body">
                                <div>
                                    <i :class="item.icon" class="color-main me-2"></i>
                                    <strong class="color-main text-uppercase">{{ item.label }}: </strong>
                                    <span>S/. {{ item.total.toFixed(2) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mt-2" id="content-timelinetable">
                <table class="table table-bordered border-main" aria-describedby="mydesc" v-if="view == 'detallado'">
                    <thead>
                        <tr class="text-white border-white text-center bg-main text-xxs">
                            <th style="vertical-align: middle" scope="col">N°</th>
                            <th style="vertical-align: middle" scope="col">TIPO</th>
                            <th style="vertical-align: middle" scope="col">OT ANTIGUA</th>
                            <th style="vertical-align: middle" scope="col">ESTADO</th>
                            <th style="vertical-align: middle" scope="col">ADM</th>
                            <th style="vertical-align: middle" scope="col">FECHA</th>
                            <th style="vertical-align: middle" scope="col">COMPROBANTE</th>
                            <th style="vertical-align: middle" scope="col">A NOMBRE DE</th>
                            <th style="vertical-align: middle" scope="col">SERIE</th>
                            <th style="vertical-align: middle" scope="col">NÚMERO</th>
                            <th style="vertical-align: middle" scope="col">
                                INFORMACIÓN DEL CLIENTE
                            </th>
                            <th style="vertical-align: middle" scope="col">
                                CONCEPTO
                            </th>
                            <th style="vertical-align: middle" scope="col">
                                DETALLE
                            </th>
                            <th style="vertical-align: middle" scope="col">
                                DOCTOR
                            </th>
                            <th style="vertical-align: middle" scope="col">MONTO</th>
                            <th style="vertical-align: middle" scope="col">MEDIO DE PAGO</th>
                            <th style="vertical-align: middle" scope="col">DOCUMENTO</th>
                        </tr>
                    </thead>
                    <tbody class="text-xxs" v-html="cpTableBodyModal"></tbody>
                </table>
            </div>
            <table id="tb-ingreso" class="table table-bordered border-main" aria-describedby="tb-egreso" v-if="view == 'consolidado'">
                <thead>
                    <tr class="text-white border-white text-center bg-main">
                        <th scope="col">N°</th>
                        <th scope="col">CATEGORIA</th>
                        <th scope="col">TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" v-for="(item2, index) in dataConsolidado" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item2.name}}</td>
                        <td> S/. {{ item2.total }}</td>

                    </tr>
                    <tr v-if="dataConsolidado.length == 0">
                        <td colspan="20" class="text-center text-xs">NO HAY REGISTROS PARA MOSTRAR</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="this.type == 'EGRESO'" class="col-md-12 px-2" id="div-tabla-egreso">
            <table v-if="view == 'detallado'" id="tb-egreso-detallado" class="table table-bordered border-main" aria-describedby="tb-egreso">
                <thead>
                    <tr class="text-white border-white text-center bg-main text-xxs">
                        <th scope="col">N°</th>
                        <th scope="col">ESTADO</th>
                        <th scope="col">ADMISIONISTA</th>
                        <th scope="col">FECHA EGRESO</th>
                        <th scope="col">FECHA DE COMPROBANTE</th>
                        <th scope="col">TIPO COMPROBANTE</th>
                        <th scope="col">TIPO</th>
                        <th scope="col">SERIE</th>
                        <th scope="col">NÚMERO</th>
                        <th scope="col">RAZÓN SOCIAL</th>
                        <th scope="col">RUC / DNI</th>
                        <th scope="col">TOTAL</th>
                        <th scope="col">MONTO PAGADO</th>
                        <th scope="col">PENDIENTE</th>
                        <th scope="col">MEDIO DE PAGO</th>
                        <th scope="col">MOTIVO, DESCRIPCIÓN O DETALLE DE COMPRA</th>
                        <th scope="col">TIPO DE EGRESO</th>
                        <th scope="col">PDF</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-xxs" v-for="(item2, index) in dataReport" :key="index">
                        <th scope="row">{{ index + 1 }}</th>
                        <td>
                            {{ item2.state == 1 ? 'PENDIENTE DE APROBACIÓN' : (item2.state == 2 || item2.state == 4 ? 'APROBADO' : 'RECHAZADO') }}
                        </td>
                        <td>
                            {{ item2.bead.user.last_name }}
                            {{ item2.bead.user.name }}
                        </td>
                        <td>{{ item2.date | formatDate }}</td>
                        <td>
                            {{
                          item2.date_doc == null
                          ? item2.date
                          : item2.date_doc | formatDate
                        }}
                        </td>
                        <td>
                            {{
                          item2.document_type_id != null
                          ? item2.document_type.name
                                    : item2.modulo == 'receipt'?"RECIBO POR HONORARIOS":"DOC. INTERNO",
                        }}
                        </td>
                        <td>{{ item2.modulo == 'passage' ? 'PASAJES' 
                    : (item2.modulo == 'expense' ? 'EGRESOS' : item2.modulo == 'receipt' ? 'RH' : 'RETIRO' ) }}</td>
                        <td>{{ item2.serie == null ? "-" : item2.serie }}</td>
                        <td>
                            {{ item2.number == null ? "-" : item2.number }}
                        </td>
                        <td>{{ item2.modulo == 'passage' ? item2.passage.name : (item2.modulo == 'retiro' ? item2.bead.user.last_name + 
                      " "+item2.bead.user.name:(item2.modulo =='receipt'? item2.receipt.name:item2.company )) }}</td>
                        <td>{{ item2.modulo == 'passage' ? item2.passage.document : (item2.modulo == 'retiro' ? item2.bead.user.dni : (
                        item2.modulo == 'receipt' ? item2.receipt.document : item2.document)) }}</td>
                        <td>{{ item2.total }}</td>
                        <td>{{ item2.amount }}</td>
                        <td>{{ item2.pending }}</td>
                        <td>{{ item2.method }}</td>
                        <td>{{ item2.description }}</td>
                        <td>{{ item2.type ? item2.type.name : 'NO ESPECIFICADO'}}</td>
                        <td>
                            <button v-if="item2.modulo == 'expense' || item2.modulo == 'receipt' || item2.modulo == 'retiro'" @click="mtdViewPdfAdjunto(item2)" title="Visualizar comprobante" class="btn btn-sm btn-info text-white mx-1">
                                <i class="fa fa-file-pdf"></i>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="dataReport.length == 0">
                        <td colspan="18" class="text-center text-xs">NO HAY REGISTROS PARA MOSTRAR</td>
                    </tr>
                </tbody>
            </table>

            <table v-if="view == 'consolidado'" id="tb-egreso-consolidado" class="table table-bordered border-main " aria-describedby="tb-egreso">
                <thead>
                    <tr class="text-white border-white text-center bg-main">
                        <th scope="col">N°</th>
                        <th scope="col">TIPO</th>
                        <th scope="col">TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" v-for="(item2, index) in dataConsolidado" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item2.modulo == 'passage' ? 'PASAJES' 
                    : (item2.modulo == 'expense' ? 'EGRESOS' : item2.modulo == 'receipt' ? 'RH' : 'RETIROS CAJA FUERTE' ) }}</td>
                        <td> S/. {{ item2.total }}</td>

                    </tr>
                    <tr v-if="dataConsolidado.length == 0">
                        <td colspan="18" class="text-center text-xs">NO HAY REGISTROS PARA MOSTRAR</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="mt-3" v-else>
        <RepDepositos :dataCampus="dataCampus" :dataBeadsList="dataBeadsList" />
    </div>
    <cModalReport :boo_modal="modalReporte.modal_form" :title="modalReporte.title" @mtdclosemodal="mtdclosemodal" :box_id="modalReporte.box_id" />
    <cModalGraficoExpense :boo_modal="modalGrafic.modal_form" :title="modalGrafic.title" @mtdclosemodal="mtdclosemodal" :box_id="modalGrafic.box_id" />
    <SweetAlert :swal="swal" ref="SweetAlert" />
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
import moment from "moment";
import exportFromJson from "export-from-json";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import RepDepositos from "./Reporte/RepDepositos.vue";
import cModalReport from "./../modal/cModalReportExport.vue";
import cModalGraficoExpense from "../modal/cModalGraficoExpenseAnnual.vue"
//import ReporteDetallado from "./Reporte/RepEgresosDetallado.vue";
export default {
    name: "c-gerencia-ingresosegresos",
    components: {
        SweetAlert,
        RepDepositos,
        cModalReport,
        cModalGraficoExpense
        // ReporteDetallado
    },
    data() {
        return {
            swal: null,
            data: [],
            view: "detallado",
            totalPagesToShow: 2,
            page: 0,
            selectPage: 1,
            stepPagination: [],
            dataShow: [],
            positem: null,
            filter: {
                venta: true,
                orden: true,
            },
            dataConsolidado: [],
            categories: [],
            categoriesModal: [],
            subcategories: [],
            subcategoriesModal: [],
            dataCampus: [],
            dataBeadsList: [],
            type: "",
            dataReport: [],
            dataReportView: [],
            filterModal: {
                campu_id: 0,
                bead_id: 0,
                begindate: null,
                enddate: null,
                eps: true,
                particular: true,
                categorie: 0,
                subcategorie: 0,
            },
            excelIncome: [],
            excelExpense: [],
            /** retiros */
            modalReporte: {
                title: "",
                modal_form: false,
                box_id: 0,
            },
            modalGrafic: {
                title: "",
                modal_form: false,
                box_id: 0,
            },
            methods: [
                { label: 'efectivo', total: 0, icon: 'far fa-money-bill-alt' },
                { label: 'tarjeta', total: 0, icon: 'fas fa-credit-card' },
                { label: 'transferencia', total: 0, icon: 'fas fa-exchange-alt' },
                { label: 'deposito', total: 0, icon: 'fas fa-money-check-alt' }
            ],
            finalCash: 0.00,

        };
    },
    created() {
        this.mtdDataBeads();
    },
    computed: {
        cpTableBodyModal() {
            let html = "";
            let aux = this.dataReport;
            let temp = aux;

            // Aplicar filtros solo si no están ambos seleccionados
            if (!(this.filter.venta && this.filter.orden)) {
                if (this.filter.venta) {
                    temp = aux.filter(el => !el.voucher.sale.orden);
                }
                if (this.filter.orden) {
                    temp = aux.filter(el => el.voucher.sale.orden);
                }
            }
            temp.forEach((element, index) => {
                let sale = element.voucher.sale;
                //concatenar el nombre del detalle de la compra
                let subategorie_name = ""
                let detail = sale.detail.map((item) => {
                    subategorie_name = item.subsub_description ?? item.subsub_categorie.subategorie.name + " " + item.subsub_categorie.name;
                    return "- " + subategorie_name;
                }).join("<br>");
                let concepto = sale.orden ? element.num_cuota == 1 ? 'ADELANTO DE ORDEN DE TRABAJO' : 'PAGO RESTANTE DE OT' : "VENTA DIRECTA";
                let type = sale.orden ? "ORDEN DE TRABAJO" : "VENTA DIRECTA";
                let doctor_name = sale.orden ? sale.orden.doctor.name + " "+ sale.orden.doctor.last_name : "-";
                let price = element.amount;
                let admisionista  = element.voucher.bead.user.name + " " + element.voucher.bead.user.last_name;
                let ticket = JSON.parse(element.voucher.sunat);
                let enlace = ticket 
                ? ticket.json.enlace_del_pdf_ticket 
                : this.$store.getters.get__url + (sale.work_order_id 
                    ? "/Admision/ticketOrden/" + element.voucher_id 
                    : "/Admision/ticketVenta/" + element.voucher_id);
                let dateFormat = element.voucher.date != null ? moment(element.voucher.date).format("DD/MM/YYYY") : "";
                let itemHtml =
                    "<tr class='tbody-table'>" +
                    "<td>" +
                    (index + 1) +
                    "</td>" +
                    "<td>" +
                    type +
                    "</td>" +
                    "<td>" +
                    (element.voucher.sale.old_ot > 0 ? element.voucher.sale.old_ot_number : '-') +
                    "</td>" +
                    "<td>" +
                    (element.voucher.state == 1 ? "ACTIVO" : "ANULADO") +
                    "</td>" +
                    "<td>" +
                    admisionista +
                    "</td>" +
                    "<td>" +
                    dateFormat +
                    "</td>" +
                    "<td>" +
                    element.voucher.document +
                    "</td>" +
                    "<td>" +
                    element.voucher.vaucher_fullname+
                    "</td>";

                    if (sale.work_order_id) {
                        itemHtml += "<td align='center' colspan='2'>OT-" + sale.work_order_id.toString().padStart(6, '0') + "</td>";
                    } else {
                        itemHtml += "<td align='center'>" + element.voucher.serie + "</td>";
                        itemHtml += "<td align='center'>" + element.voucher.number + "</td>";
                    }

                    itemHtml += 
                    "<td>" +
                    sale.patient.name +
                    "</td>" +
                    "<td>" +
                    concepto +
                    "</td>" +
                   "<td>" +
                    detail +
                    "</td>" +
                    "<td>" +
                    doctor_name +
                    "</td>" +
                    "<td>" +
                    parseFloat(price).toFixed(2) +
                    "</td>" +
                    "<td>" +
                    (element.method ? element.method : '-') +
                    "</td>" +
                    "<td>" +
                    "<a id='btn-check'  style='margin-left: 5px; font-weight: bold; text-decoration: none;' href='" +
                    enlace +
                    "' target='_blank'>" +
                    "<i class='fas fa-file-pdf'></i><span  style='font-size: 13px;'> VER DOC.</span>" +
                    "</a>" +
                    "</td>" +
                    "</tr>";

                    html += itemHtml;
            });
            if (temp.length == 0) {
                html =
                    "<tr><td colspan='18' align='center'>NO HAY REGISTROS PARA MOSTRAR</td><tr>";
            }
            return html;
        },
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdChangeState: function () {
            this.view = this.view == 'detallado' ? 'consolidado' : 'detallado';

            if (this.view == 'consolidado') {
                if (this.dataConsolidado.length == 0) {
                    this.mtdDataReportConsolidado();
                }
            }
        },
        mtdViewPdfAdjunto: function (expense) {
            const baseUrl = "https://clinicabm.v2.howertpi.com/assets/";

            // Manejar archivo adjunto en módulo 'receipt'
            if (expense.modulo === 'receipt') {
                return this.openFile(expense.receipt?.file, baseUrl);
            }

            // Manejar archivo adjunto en módulo 'retiro'
            if (expense.modulo === 'retiro') {
                const route = `/Permisions/viewpdf/expense/${expense.id}`;
                window.open(this.$store.getters.get__url + route, "_blank");
                return;
            }

            // Manejar otros casos
            if (!expense.file) {
                this.$refs.SweetAlert.showWarning("No hay archivo adjunto", "warning");
                return;
            }

            // Verificar si el archivo es un JSON válido
            try {
                const files = JSON.parse(expense.file);
                if (Array.isArray(files)) {
                    files.forEach(file => this.openFile(file.route, baseUrl));
                } else {
                    throw new Error("Formato de archivo inválido");
                }
            } catch (e) {
                // Si no es JSON, asumir que es una ruta de archivo única
                this.openFile(expense.file, baseUrl);
            }
        },

        openFile: function (filePath, baseUrl) {
            if (filePath) {
                window.open(baseUrl + filePath, "_blank");
            } else {
                this.$refs.SweetAlert.showWarning("No se pudo abrir el archivo", "warning");
            }
        },

        returnHome: function () {
            this.$emit("returnHome", "home");
        },
        mtdReportBead: function (type) {
            if (this.type != type) {
                this.mtdHideModal();
            }
            this.filterModal.campu_id = this.$store.getters.get__campus;
            this.type = type;
            if (type == 'INGRESO') {
                this.view = 'detallado';
            }

            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7);
            const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            this.filterModal.begindate = firstDayOfMonth.toISOString().split('T')[0];
            this.filterModal.enddate = today.toISOString().split('T')[0];
        },
        mtdDataReportConsolidado: function () {
            this.dataConsolidado = [];
            if (this.filterModal.bead_id !== 0 && this.type == 'EGRESO') {
                this.post({
                        url: this.$store.getters.get__url + "/ReportesCajas/egresosConsolidado",
                        token: this.$store.getters.get__token,
                        params: this.filterModal,
                    })
                    .then((response) => {
                        this.dataConsolidado = response.data;
                    })
                    .catch((errors) => {});
            }
            if (this.filterModal.bead_id !== 0 && this.type == 'INGRESO') {

                this.post({
                        url: this.$store.getters.get__url + "/ReportesCajas/ingresosConsolidado",
                        token: this.$store.getters.get__token,
                        params: this.filterModal,
                    })
                    .then((response) => {
                        this.dataConsolidado = response.data;
                    })
                    .catch((errors) => {});

            }
        },
        mtdHideModal: function () {
            this.type = "";
            this.filterModal.campu_id = 0;
            this.filterModal.bead_id = 0;
            this.filterModal.begindate = "";
            this.filterModal.enddate = "";
            this.dataReport = [];
            this.dataConsolidado = [];
        },
        mtdSelectCampusToBox: function () {
            this.dataBeadsList = [];
            this.dataCampus.forEach((element) => {
                if (element.id == this.filterModal.campu_id) {
                    this.dataBeadsList = element.boxes;
                }
            });
        },
        mtdDataReport: function () {
            if (this.filterModal.campu_id == 0) {
                Swal.fire({
                    text: "Escoja una sede!!",
                    icon: "warning",
                    confirmButtonColor: "#43517A",
                });
                return;
            }
            if (this.filterModal.bead_id == 0) {
                Swal.fire({
                    text: "Escoja una caja!!",
                    icon: "warning",
                    confirmButtonColor: "#43517A",
                });
                return;
            }
            this.mtdDataReportConsolidado();
            this.get({
                    url: this.$store.getters.get__url +
                        "/ReportesCajas/reportecajaRe?type=" +
                        this.type +
                        "&campu_id=" +
                        this.filterModal.campu_id +
                        "&bead_id=" +
                        this.filterModal.bead_id +
                        "&begindate=" +
                        this.filterModal.begindate +
                        "&enddate=" +
                        this.filterModal.enddate,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.dataReport = response.data;
                    this.clearTotal();
                    this.calculateTotal();
                    this.prepareExcelData();
                    this.mtdSetCategoriesModal();
                    this.mtdSetSubcategoriesModal();
                })
                .catch((errors) => {});
        },
        clearTotal: function(){
            this.finalCash = 0.00;
            this.methods.forEach(method => {
                method.total = 0.00;
            });
        },
        calculateTotal: function(){
            this.clearTotal();
            let aux = this.dataReport;
            let temp = aux;

            // Aplicar filtros solo si no están ambos seleccionados
            if (!(this.filter.venta && this.filter.orden)) {
                if (this.filter.venta) {
                    temp = aux.filter(el => !el.voucher.sale.orden);
                }
                if (this.filter.orden) {
                    temp = aux.filter(el => el.voucher.sale.orden);
                }
            }
            temp.forEach(element => {
                        //sumar el total de la caja y agrupando por method
                        this.finalCash += parseFloat(element.amount);
                        this.methods.forEach(method => {
                            if(element.method == method.label) {
                                method.total += parseFloat(element.amount);
                            }
                        });
            });
            this.prepareExcelData();
        },
        prepareExcelData: function (){
            this.excelIncome = [];
            this.excelExpense = [];
            let aux = this.dataReport;
            let filtered = aux;

            if (!(this.filter.venta && this.filter.orden)) {
            if (this.filter.venta) {
                filtered = aux.filter(el => !el.voucher.sale.orden);
            }
            if (this.filter.orden) {
                filtered = aux.filter(el => el.voucher.sale.orden);
            }
            }
            filtered.forEach((element, index) => {
                        if (this.type == "INGRESO") {
                            let sale = element.voucher.sale;
                            let subategorie_name = "";
                            let detail = sale.detail.map((item) => {
                                subategorie_name = item.subsub_description ?? item.subsub_categorie.subategorie.name + " " + item.subsub_categorie.name;
                                return "- " + subategorie_name;
                            }).join("\n");
                            let concepto = sale.orden ? element.num_cuota == 1 ? 'ADELANTO DE ORDEN DE TRABAJO' : 'PAGO RESTANTE DE OT' : "VENTA DIRECTA";
                            let type = sale.orden ? "ORDEN DE TRABAJO" : "VENTA DIRECTA";
                            let doctor_name = sale.orden ? sale.orden.doctor.name + " " + sale.orden.doctor.last_name : "-";
                            let price = element.amount;
                            let admisionista = element.voucher.bead.user.name + " " + element.voucher.bead.user.last_name;
                            let dateFormat = element.voucher.date != null ? moment(element.voucher.date).format("DD/MM/YYYY") : "";
                            let serieNumero = sale.work_order_id 
                                ? "OT-" + sale.work_order_id.toString().padStart(6, '0') 
                                : `${element.voucher.serie} - ${element.voucher.number}`;
                            this.excelIncome.push({
                                "N°": index + 1,
                                "TIPO": type,
                                "OT ANTIGUA": (element.voucher.sale.old_ot > 0 ? element.voucher.sale.old_ot_number : '-'),
                                "ESTADO": element.voucher.state == 1 ? "ACTIVO" : "ANULADO",
                                "ADMISIONISTA": admisionista,
                                "FECHA": dateFormat,
                                "COMPROBANTE": element.voucher.document,
                                "A NOMBRE DE": element.voucher.vaucher_fullname,
                                "SERIE / NÚMERO": serieNumero,
                                "INFORMACIÓN DEL CLIENTE": sale.patient.name,
                                "CONCEPTO": concepto,
                                "DETALLE": detail,
                                "DOCTOR": doctor_name,
                                "MONTO": parseFloat(price).toFixed(2),
                                "MEDIO DE PAGO": element.method ? element.method : '-',
                            });
                        
                        }  else {
                            this.excelExpense.push({
                                "N°": index + 1,
                                ESTADO: element.state == 1 ?
                                    "PENDIENTE DE APROBACIÓN" : element.state == 2 || element.state == 4 ?
                                    "APROBADO" : "RECHAZADO",
                                "ADMISIONISTA": element.bead.user.last_name + " " + element.bead.user.name,
                                "TIPO": element.modulo == 'passage' ? 'PASAJES' : (element.modulo == 'expense' ? 'EGRESOS' : element.modulo == 'receipt' ? 'RH' : 'RETIROS CAJA FUERTE'),
                                "FECHA DE EGRESO": element.date,
                                "FECHA DE COMPROBANTE": element.date_doc == null ? element.date : element.date_doc,
                                "TIPO DE COMPROBANTE": element.document_type_id != null ?
                                    element.document_type.name : element.modulo == "receipt" ?
                                    "RECIBO POR HONORARIOS" : "DOC. INTERNO",
                                "NÚMERO DE COMPROBANTE": element.modulo == "passage" ?
                                    "PLANILLA-PASAJES" : element.number ?
                                    element.serie + "-" + element.number : element.serie ?
                                    element.serie : "-",
                                "RAZON SOCIAL/NOMBRE": element.modulo == "passage" ?
                                    element.passage.name : element.modulo == "retiro" ?
                                    element.bead.user.last_name + " " + element.bead.user.name : element.modulo == "receipt" ?
                                    element.receipt.name : element.company,
                                "RUC/DNI": element.modulo == "passage" ?
                                    element.passage.document : element.modulo == "retiro" ?
                                    element.bead.user.dni : element.modulo == "receipt" ?
                                    element.receipt.document : element.document,
                                TOTAL: element.total,
                                "MONTO PAGADO": element.amount,
                                PENDIENTE: element.pending,
                                "MEDIO DE PAGO": element.method,
                                "MOTIVO, DESCRIPCION O DETALLE DE COMPRA": element.description,
                            });
                        }
                    });
        },
        mtdSetCategoriesModal: function () {
            this.categoriesModal = [];
            let str = "";
            if (this.type == 'EGRESO') {
                this.dataReport.forEach((element) => {
                    element.voucher.sale.detail.forEach((ele) => {
                        if (
                            !str.includes(
                                "," + ele.subsub_categorie.subategorie.categorie.id + ","
                            )
                        ) {
                            this.categoriesModal.push({
                                label: ele.subsub_categorie.subategorie.categorie.name,
                                id: ele.subsub_categorie.subategorie.categorie.id,
                            });
                            str += "," + ele.subsub_categorie.subategorie.categorie.id + ",";
                        }
                    });
                });
            } else {
                const uniqueCategoriesSet = new Set();
                this.dataReport.forEach(element => {
                    ;
                    const uniqueKey = `${element.category_name}-${element.cat_id}`;
                    if (!uniqueCategoriesSet.has(uniqueKey)) {
                        uniqueCategoriesSet.add(uniqueKey);
                        this.categoriesModal.push({
                            label: element.category_name,
                            id: element.cat_id
                        });
                    }
                });
            }
        },
        mtdSetSubcategoriesModal: function () {
            let str = "";
            this.dataReport.forEach((element) => {
                element.voucher.sale.detail.forEach((ele) => {
                    if (!str.includes("," + ele.subsub_categorie.subategorie.id + ",")) {
                        this.subcategoriesModal.push({
                            label: ele.subsub_categorie.subategorie.name,
                            id: ele.subsub_categorie.subategorie.id,
                            categorie: ele.subsub_categorie.subategorie.categorie.id,
                        });
                        str += "," + ele.subsub_categorie.subategorie.id + ",";
                    }
                });
            });

        },
        exportExcel: function () {
            const datos =
                this.type == "INGRESO" ? this.excelIncome : this.excelExpense;
            const fileName = this.type;
            const typeExport = exportFromJson.types.xls;
            exportFromJson({
                data: datos,
                fileName: fileName,
                exportType: typeExport,
            });
        },
        FormatJson(FilterData, JsonData) {
            return JsonData.map((v) =>
                FilterData.map((j) => {
                    return v[j];
                })
            );
        },

        mtdDataBeads: function () {
            this.filterModal.campu_id = this.$store.getters.get__campus;
            //let originPage = 'admision'
            let originPage = 'OPTICA'
            this.post({
                    url: this.$store.getters.get__url + "/Bead/reportClose",
                    token: this.$store.getters.get__token,
                    params: {
                        id: this.filterModal.campu_id,
                        pageOrigin: originPage,
                        campus_id: this.$store.getters.get__campus
                    }
                })
                .then((response) => {
                    this.dataCampus = response.data.campus;
                    this.mtdSelectCampusToBox();
                })
                .catch(() => {});
        },
        showGraficExpenseYear: function () {
            //mostrar el modal del gráfico anuales
            this.modalGrafic = {
                title: "GRAFICO DE EGRESOS ANUALES",
                modal_form: true,
                box_id: this.filterModal.bead_id,
            }
        },
        showGrafic: function () {
            //mostrar el modal del gráfico
            this.modalReporte = {
                title: "GRAFICO DE EGRESOS",
                modal_form: true,
                box_id: this.filterModal.bead_id,
            }

        },
        mtdclosemodal() {
            this.modalReporte = {
                    title: "",
                    modal_form: false,
                    box_id: 0,
                },
                this.modalGrafic = {
                    title: "",
                    modal_form: false,
                    box_id: 0,
                }
        },
        mtdChangeView: function (option) {
            this.$emit("mtdChangePage", option);
        },
    },

    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatTime(time) {
            let arTime = time.split(":");
            if (arTime[0] <= 12) {
                return time + " am";
            } else {
                return arTime[0] - 12 + ":" + arTime[1] + ":" + arTime[2] + " pm";
            }
        },
    },
}
</script>
